<template>
  <div class="pagination">
    <div v-swiper:mySwiper="swiperOption">
      <div class="pagination-list swiper-wrapper">
        <div
          v-for="item in visible_list"
          @click="change_index(item.index)"
          :key="item.index"
          :disabled="disabled || item.disabled"
          :class="[
            'swiper-slide pagination-item',
            {
              is_active: item.is_active,
              is_available: item.is_available,
              is_done: item.is_done,
              is_skipped: item.is_skipped
            }
          ]"
        >
          {{ item.index + 1 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
  import 'swiper/swiper-bundle.css';

  export default {
    name: 'videointerview-paginator',

    components: {
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    },

    props: {
      list: Array,
      disabled: Boolean
    },

    data() {
      return {
        start_index: 0,
        swiperOption: {
          slidesPerView: 'auto',
          spaceBetween: 0
        }
      };
    },

    methods: {
      change_index(index) {
        this.$emit('change_index', index);
      }
    },

    computed: {
      visible_list() {
        if (!this.list || !this.list.length) {
          return [];
        }

        return this.list;
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../../../assets/styles/colors.scss';

  .pagination {
    position: relative;
    width: 100%;
    justify-content: center;
    border-radius: 0;
    margin: 0;
    padding: 0;
  }

  .pagination-list {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0;
    border-radius: 0;
  }

  .pagination-arrow,
  .pagination-item {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    color: #233346;
    text-decoration: none;
    padding: 0 20px;
    list-style: none;
    cursor: pointer;
    transition: all 0.7s;
    text-align: center;
    user-select: none;
    background: #f4f5f7;
    height: 40px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
    min-width: 60px;
    width: 60px;

    &:hover {
      background: $green-disabled;
    }
    &.is_skipped {
      background: #f4f5f7;
    }

    &.is_done {
      background: $green-disabled;
    }

    &.is_active {
      background: $green-disabled;
    }

    &.is_done.is_active {
      background: $green-disabled;
    }

    &.pagination-shift {
      cursor: pointer;
      &.pagination-shift-hidden {
        visibility: hidden;
        cursor: default;
      }
    }
  }

  .pagination-arrow {
    &.is_hidden {
      visibility: hidden;
      cursor: default;
    }
  }
</style>
